import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../apiClient";

export const deleteBusSimulate = ({ id }) => {
  return api.delete(`/admin/buses-v2/simulate/${id}`);
};

export const deleteBusSimulateQueryOptions = data => {
  return queryOptions({
    queryKey: ["delete-bus-simulate", data],
    queryFn: () => deleteBusSimulate(data),
  });
};

export const useDeleteBusSimulate = ({ queryConfig = {}, ...data }) => {
  return useQuery({
    ...deleteBusSimulateQueryOptions(data),
    ...queryConfig,
  });
}; 